<template>
  <tab-content-layout title="COMPRA">
    <b-modal
      id="stock_item_price_list"
      title="TABELA DE PREÇO"
      hide-footer
      no-close-on-backdrop
      size="lg"
    >
      <stock-item-price-list
        :stock_item="stock_item"
        @value="handleValueStockItemPriceList"
      />
    </b-modal>
    <template #top-right-button>
      <v-btn-import
        :disabled="
          !financial ||
          (financial && !financial.providerId) ||
          !stock_owner_group_id
        "
        @click="openImportNFe"
      />
      <input
        :disabled="
          !financial ||
          (financial && !financial.providerId) ||
          !stock_owner_group_id
        "
        type="file"
        id="import-input"
        accept=".xml"
        hidden
        @change="importNFe"
      />
    </template>
    <div
      class="text-right text-danger"
      v-if="
        !financial ||
        (financial && !financial.providerId) ||
        !stock_owner_group_id
      "
    >
      <p v-if="!financial || (financial && !financial.providerId)" class="m-0">
        Informe o fornecedor para poder importar a nota fiscal!
      </p>
      <p v-if="!stock_owner_group_id" class="m-0">
        Informe o grupo estoque de destino para poder importar a nota fiscal!
      </p>
    </div>
    <new-provider
      :default-company-name="new_provider.company_name"
      :defaultCPFCNPJ="new_provider.cpf_cnpj"
      @created="handleSuccessProvider"
    />
    <add-item
      :type="type"
      :stock_groups="stock_groups"
      :stock_group_has_stock_item_category="stock_group_has_stock_item_category"
      :stock_item_categories="stock_item_categories"
      :stock_items="stock_items"
      :stock_item_units_of_measurement="stock_item_units_of_measurement"
      :stock_owner_group_id="stock_owner_group_id"
      @created="evOnPurchaseItemCreated"
      @search="getStockItems"
    />
    <edit-item
      :type="type"
      :provider_id="financial ? financial.providerId : null"
      :purchase_item="purchase_item"
      :stock_groups="stock_groups"
      :stock_group_has_stock_item_category="stock_group_has_stock_item_category"
      :stock_item_categories="stock_item_categories"
      :stock_items="stock_items"
      :stock_items_by_provider_id="stock_items_by_provider_id"
      :stock_item_units_of_measurement="stock_item_units_of_measurement"
      :imported_nfe="imported_nfe"
      :nfe_change_name_item="nfe_change_name_item"
      :nfe="nfe"
      @updated="evOnPurchaseItemUpdated"
      @close="purchase_item = null"
      @new-item="openNewItem"
      @search="getStockItems"
    />
    <b-modal
      id="new_product"
      title="NOVO PRODUTO"
      hide-footer
      no-close-on-backdrop
    >
      <new-product
        :default-name="new_item_name"
        :stock_item_categories="stock_item_categories"
        :stock_item_units_of_measurement="stock_item_units_of_measurement"
        :product_units_of_measurement="units_of_measurement"
        @created="getStockItems"
      />
    </b-modal>
    <b-modal
      id="new_medicine"
      title="NOVO MEDICAMENTO"
      size="lg"
      hide-footer
      no-close-on-backdrop
    >
      <new-medicine
        :default-name="new_item_name"
        :stock_item_categories="stock_item_categories"
        :stock_item_units_of_measurement="stock_item_units_of_measurement"
        :standardUnitOfMeasurement="unitOfMeasurements"
        :active_ingredient="active_ingredient"
        :typesOfMedicine="typesOfMedicine"
        :typesOfRecipe="typesOfRecipe"
        @created="getStockItems"
      />
    </b-modal>
    <b-row class="v-clean mb-2">
      <b-col>
        <label>RESIDENTES ATIVO/INATIVO</label>
        <v-select
          outlined
          dense
          :items="[
            { id: null, name: 'TODOS' },
            { id: 'ATIVO', name: 'ATIVO' },
            { id: 'INATIVO', name: 'INATIVO' },
          ]"
          item-text="name"
          item-value="id"
          label=""
          @change="getResidents"
          v-model="status_resident"
        />
      </b-col>
      <b-col>
        <label-required-field label="ESTOQUE DE DESTINO" />
        <v-autocomplete-default
          label=""
          :items="residents"
          v-model="stock_owner_id"
        />
      </b-col>
      <b-col>
        <label-required-field label="GRUPO ESTOQUE DE DESTINO" />
        <v-autocomplete-default
          @change="handleStockOwnerGroupId"
          label=""
          :items="stock_groups"
          v-model="stock_owner_group_id"
        />
      </b-col>
      <b-col>
        <label-required-field label="PRODUTO/MEDICAMENTO" />
        <v-autocomplete-default
          @change="handleChangeType"
          :disabled="listable_purchase_items.length > 0"
          label=""
          :items="types"
          v-model="type"
        />
      </b-col>
    </b-row>
    <b-row class="v-clean mb-3">
      <b-col>
        <financial
          v-model="financial"
          :providerId="providerId"
          @providersRefreshed="parseNFeProvider"
        />
        <warning-required-fields />
      </b-col>
    </b-row>
    <b-row class="v-clean">
      <b-col>
        <b-row>
          <b-col>
            <h4 class="title-pages">PRODUTOS/MEDICAMENTOS</h4>
          </b-col>
          <b-col cols="auto">
            <v-btn-add v-if="!nfe" @click="$bvModal.show('add_item')" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <v-data-table-default
              :items="listable_purchase_items"
              :headers="purchase_items_headers"
              :footerProps="{
                'items-per-page-options': [100, 200, 300],
                'items-per-page-text': 'Mostrar',
              }"
            >
              <template #[`body.append`]>
                <tr v-for="row in listable_append_rows" :key="row.name">
                  <td
                    v-for="header in purchase_items_headers"
                    :key="header.value"
                  >
                    <span v-if="header.value == 'name'">
                      {{ row[header.value] }}
                    </span>
                    <span v-if="header.value == 'value'">
                      R$ {{ formatValueOnKeyUp(String(row[header.value])) }}
                    </span>
                  </td>
                </tr>
              </template>
              <template #[`item.nfe_code`]="{ item }">
                {{ item.nfe_code ? item.nfe_code : "N/A" }}
              </template>
              <template #[`item.status`]="{ item }">
                <v-icon :color="item.status.color">
                  {{ item.status.icon }}
                </v-icon>
              </template>
              <template #[`item.quantity`]="{ item }">
                <v-text-field-default
                  type="number"
                  label=""
                  required
                  v-model="item.amount"
                  @input="handleInputAmount($event, item)"
                />
                <p class="m-0" v-if="item.nfe_amount">
                  {{ item.nfe_amount }}
                </p>
              </template>
              <template #[`item.amount`]="{ item }">
                <div v-if="item.stock_item_type == 'PRODUCT'">
                  {{ item.size ? item.size : 1 * item.amount }}
                  {{ item.unit_of_measurement_abbreviation }}
                </div>
                <div v-if="item.stock_item_type == 'MEDICINE'">
                  {{ item.amount }} {{ item.unit_of_measurement_abbreviation }}
                </div>
                <div v-if="!item.stock_item_type">
                  {{ item.amount }} {{ item.unit_of_measurement_abbreviation }}
                </div>
              </template>
              <template #[`item.unitary_value`]="{ item }">
                R$ {{ item.unitary_value }}
              </template>
              <template #[`item.value`]="{ item }">
                R$ {{ item.value }}
              </template>
              <template #[`item.edit`]="{ item }">
                <v-data-table-edit-button
                  :disabled="imported_nfe && !financial.providerId"
                  @click="handleClickItem(item)"
                />
                <confirmation-dialog
                  v-if="!nfe"
                  class="mr-2"
                  small
                  message-title="REMOVER?"
                  message-body="Deseja realmente remover o item?"
                  open-class="btn-delete"
                  open-left-icon="fa-trash"
                  open-text="REMOVER"
                  @yes="removePurchaseItem(item)"
                />
              </template>
              <template #[`item.price`]="{ item }">
                <v-btn
                  v-if="item.stock_item_id"
                  small
                  @click="handleModalVerifyStockItemPriceList(item)"
                  class="btn-edit m-1"
                >
                  <i class="fas fa-dollar-sign mr-2 text-twenty"></i>
                  TABELA DE PREÇO
                </v-btn>
              </template>
            </v-data-table-default>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <errors-messages :errors="errors" />
    <b-row align-h="end">
      <b-col cols="auto">
        <v-btn-save
          :disabled="btnExecuteDisabled || loading"
          text="EXECUTAR"
          @click="execute"
        />
      </b-col>
    </b-row>
  </tab-content-layout>
</template>

<script>
import TabContentLayout from "../../Components/TabContentLayout.vue";
import VAutocompleteDefault from "../../Components/VAutocompleteDefault.vue";
import VBtnAdd from "../../Components/VBtnAdd.vue";
import VBtnImport from "../../Components/VBtnImport.vue";
import VTextFieldDefault from "../../Components/VTextFieldDefault.vue";
import EditItem from "./purchase/edit-item.vue";
import VDataTableDefault from "../../Components/VDataTableDefault.vue";
import VDataTableEditButton from "../../Components/VDataTableEditButton.vue";
import ConfirmationDialog from "../../Components/ConfirmationDialog.vue";
import LabelRequiredField from "../../Components/LabelRequiredField.vue";
import NewProvider from "../../Financial/Provider/NewProvider.vue";
import AddItem from "./purchase/add-item.vue";
import StockItemPriceList from "./purchase/purchase-stock-item-price-list.vue";

import NewProduct from "../../Components/Stock/new-product.vue";
import NewMedicine from "../../Components/Stock/new-medicine.vue";

import api from "../../../services/api";

import APIGet from "../../../lib/api-get";

import {
  formatPrice,
  formatValueOnKeyUp,
  localeFormat,
  numbersOnly,
} from "../../../lib/format";

import parseNFeV4 from "../../../lib/nfe";
import VBtnSave from "../../Components/VBtnSave.vue";
import toast from "../../../lib/ToastNotification";
import ErrorsMessages from "../../Components/ErrorsMessages.vue";
import moment from "moment";
import WarningRequiredFields from "../../Components/WarningRequiredFields.vue";
import Financial from "./purchase/financial.vue";

export default {
  name: "Purchase",

  components: {
    TabContentLayout,
    VBtnImport,
    VTextFieldDefault,
    VAutocompleteDefault,
    VBtnAdd,
    EditItem,
    VDataTableDefault,
    VDataTableEditButton,
    LabelRequiredField,
    NewProvider,
    AddItem,
    StockItemPriceList,
    NewProduct,
    NewMedicine,
    VBtnSave,
    ErrorsMessages,
    ConfirmationDialog,
    WarningRequiredFields,
    Financial,
  },

  data() {
    return {
      status_resident: "ATIVO",

      nfe_change_name_item: null,

      stock_item: null,

      imported_nfe: false,
      loading: false,
      loadingVerify: false,
      verified: false,
      errors: [],

      nfe: null,

      financial: null,
      stock_owner_group_id: null,
      providerId: 0,
      nfeId: null,

      purchase_item_status: Object.freeze({
        VERIFIED: { icon: "mdi-check-circle-outline", color: "success" },
        WARNING: { icon: "mdi-information-outline", color: "orange" },
        ERROR: { icon: "mdi-close-circle-outline", color: "error" },
      }),

      original_providers: [],
      stock_items: [],
      stock_items_by_provider_id: [],
      stock_groups: [],
      stock_group_has_stock_item_category: [],
      raw_residents: [],

      purchase_items_headers: [
        { text: "CÓDIGO DO FORNECEDOR", value: "nfe_code", sortable: false },
        { text: "ITEM", value: "name", sortable: false },
        { text: "QTD. UNIDADE", value: "quantity", sortable: false },
        { text: "QTD. UNIDADE DE MEDIDA", value: "amount", sortable: false },
        { text: "VALOR UNITÁRIO", value: "unitary_value", sortable: false },
        { text: "VALOR TOTAL", value: "value", sortable: false },
        { text: "GRUPO", value: "stock_group_name", sortable: false },
        {
          text: "SITUAÇÃO",
          value: "status",
          sort: (a, b) => a.color.localeCompare(b.color),
          sortable: false,
        },
        { text: "EDITAR", value: "edit", sortable: false },
        { text: "PREÇO", value: "price", sortable: false },
      ],

      /**
       * @type {{
       *   stock_item_id: number,
       *   amount: number,
       *   quantity: number,
       *   size: number,
       *   unit_of_measurement_abbreviation: string,
       *   lot: string,
       *   description: string,
       *   due_date: string,
       *   stock_group_id: number,
       *   value: number,
       *   stock_item_type: string,
       *   name: string,
       *   medicine_id: number,
       *   product_id: number,
       *   imported_nfe: boolean,
       *   imported_nfe_type: string,
       *   nfe_amount: string,
       *   nfe_code: string,
       *   nfe_name: string,
       * }[]}
       */
      purchase_items: [],
      purchase_item: null,

      stock_owner_id: null,

      new_provider: {
        company_name: "",
        cpf_cnpj: "",
      },

      new_item_name: "",

      unitOfMeasurements: [],
      active_ingredient: [],
      typesOfMedicine: [],
      typesOfRecipe: [],
      categories: [],
      units_of_measurement: [],
      stock_item_categories: [],
      stock_item_units_of_measurement: [],

      types: [
        // { id: "ALL", name: "PRODUTO/MEDICAMENTO" },
        { id: "PRODUCT", name: "PRODUTO" },
        { id: "MEDICINE", name: "MEDICAMENTO" },
      ],
      type: "PRODUCT",

      purchase_shipping_total: {
        name: "TRANSPORTE/FRETE",
        value: "",
      },
      purchase_items_total: {
        name: "TOTAL PRODUTOS",
        value: "",
      },
      purchase_discount_total: {
        name: "DESCONTOS",
        value: "",
      },
      purchase_total: {
        name: "TOTAL COMPRA",
        value: "",
      },
    };
  },

  created() {
    this.retrieve().then();
  },

  computed: {
    providers() {
      return [
        { company_name: "SELECIONE", id: null },
        ...this.original_providers,
      ];
    },

    residents() {
      return [{ id: null, name: "EMPRESA" }, ...this.raw_residents];
    },

    listable_purchase_items() {
      return this.purchase_items.map((purchase_item, index) => {
        const stock_group = this.stock_groups.find(
          (group) => group.id === purchase_item.stock_group_id
        );

        return {
          ...purchase_item,
          index,
          name: purchase_item?.name ?? purchase_item.nfe_name,
          stock_group_name: stock_group?.name ?? null,
        };
      });
    },

    listable_append_rows() {
      const append_rows = [
        this.purchase_items_total,
        this.purchase_shipping_total,
        this.purchase_other_costs_total,
        this.purchase_discount_total,
        this.purchase_total,
      ];
      return append_rows.filter((row) => row.value > 0);
    },

    importInput() {
      return document.getElementById("import-input");
    },

    btnExecuteDisabled() {
      if (this.purchase_items.length === 0) return true;
      if (!this.financial?.dueDatePaymentDate) return true;
      if (!this.financial?.providerId) return true;

      return false;
    },

    purchase_other_costs_total() {
      return {
        name: "OUTROS VALORES",
        value: Number(
          (
            Number(this.purchase_total.value) -
            Number(this.purchase_discount_total.value) -
            Number(this.purchase_shipping_total.value) -
            Number(this.purchase_items_total.value)
          ).toFixed(2)
        ),
      };
    },

    computed_purchase_items_total() {
      let { purchase_items } = this;
      let total = 0;
      for (let item of purchase_items) {
        let replace = String(item.value)
          .replace(".", "")
          .replace(".", "")
          .replace(".", "")
          .replace(".", "")
          .replace(",", ".");

        total = parseFloat(total) + parseFloat(replace);
      }

      return total.toFixed(2);
    },
  },

  watch: {
    financial: {
      handler(old, cur) {
        if (cur?.providerId !== old?.providerId) this.refreshNFeItems().then();
      },
      deep: true,
    },
  },

  methods: {
    localeFormat,
    formatValueOnKeyUp,
    moment,

    handleClickItem(item) {
      this.purchase_item = item;
    },

    handleModalVerifyStockItemPriceList(stock_item) {
      let { stock_item_id } = stock_item;
      if (stock_item_id) {
        this.stock_item = stock_item;
        this.$bvModal.show("stock_item_price_list");
      }
    },

    async handleInputAmount(amount, item) {
      let { value } = item;

      value = String(value)
        .replace("R$", "")
        .replace(" ", "")
        .replace(",", "")
        .replace(".", "")
        .replace(".", "")
        .replace(".", "");

      if (amount) {
        amount = String(amount).replace(",", ".");

        let unit = parseFloat(value) / parseFloat(amount);

        if (unit) {
          item.unitary_value = formatPrice(String(unit));
        } else {
          item.unitary_value = formatPrice(String(value));
        }
      } else {
        item.unitary_value = formatPrice(String(value));
      }

      const { index } = item;

      delete item.index;

      const purchase_item = {
        ...this.purchase_items[index],
        ...item,
      };

      this.purchase_items.splice(index, 1, purchase_item);

      this.purchase_items_total.value = this.computed_purchase_items_total;
      this.updateFinancialLaunchValue();
    },

    async verifyNFeItem(code) {
      try {
        this.loadingVerify = true;

        let { financial } = this;

        let provider_id =
          financial && financial.providerId ? financial.providerId : null;

        if (provider_id) {
          let params = { code, provider_id };

          const response = await api.get("/rest-home/stock/item/verify", {
            params,
          });

          const { error, exist, stock_item_provider_code } = response.data;

          this.loadingVerify = false;

          if (!error) {
            return {
              exist,
              stock_item_provider_code,
            };
          } else {
            return {
              exist: false,
              stock_item_provider_code: false,
            };
          }
        } else {
          this.loadingVerify = false;
          return {
            exist: false,
            stock_item_provider_code: false,
          };
        }
      } catch (error) {
        this.loadingVerify = false;
        return {
          exist: false,
          stock_item_provider_code: false,
        };
      }
    },

    async handleStockOwnerGroupId() {
      let {
        purchase_items,
        stock_owner_group_id,
        stock_groups,
        purchase_item_status,
        verified,
        nfe_change_name_item,
      } = this;

      if (!verified) {
        for (let i = 0; i < purchase_items.length; i++) {
          let purchase_item = purchase_items[i];

          const stock_group = stock_groups.find(
            (group) =>
              group.id ===
              (purchase_item.stock_group_id
                ? purchase_item.stock_group_id
                : stock_owner_group_id)
          );

          let status = purchase_item_status.ERROR;

          if (purchase_item.imported_nfe) {
            let verifyNFeItem = await this.verifyNFeItem(
              purchase_item.nfe_code
            );
            if (verifyNFeItem.exist) {
              purchase_item.stock_item_id =
                verifyNFeItem.stock_item_provider_code.stock_item_id;
              purchase_item.stock_item_type =
                verifyNFeItem.stock_item_provider_code.type;
              purchase_item.imported_nfe_type =
                verifyNFeItem.stock_item_provider_code.type;
              purchase_item.unit_of_measurement_abbreviation =
                verifyNFeItem.stock_item_provider_code.unit_of_measurement_abbreviation;
              purchase_item.size = verifyNFeItem.stock_item_provider_code.size;
              purchase_item.stock_item_unit_of_measurement_id =
                verifyNFeItem.stock_item_provider_code.stock_item_unit_of_measurement_id;

              if (nfe_change_name_item == 1) {
                purchase_item.name =
                  verifyNFeItem.stock_item_provider_code.name;
              }

              if (purchase_item.stock_item_type == "PRODUCT") {
                status = purchase_item_status.VERIFIED;
                purchase_item.quantity =
                  parseFloat(verifyNFeItem.stock_item_provider_code.size) *
                  parseFloat(purchase_item.amount);
              }
            }
          }

          if (!purchase_item.stock_group_id) {
            purchase_item.stock_group_id = stock_owner_group_id;
          }

          this.purchase_items[i] = {
            ...purchase_item,
            index: i,
            name: purchase_item?.name ?? purchase_item.nfe_name,
            stock_group_name: stock_group?.name ?? null,
            status,
          };
        }
        this.verified = true;
      }
    },

    handleSuccessProvider(id) {
      this.providerId = Number(id);
      this.refreshProviders = !this.refreshProviders;
    },

    //#region retrievers
    async retrieve() {
      if (this.errors.length === 0) await this.getConfigNfe();
      if (this.errors.length === 0) await this.getResidents();
      if (this.errors.length === 0) await this.getStockItemUnitsOfMeasurement();
      if (this.errors.length === 0) await this.getStockGroups();
      if (this.errors.length === 0)
        await this.getStockGroupsAssociatedCategories();
      if (this.errors.length === 0) await this.getCategories();
      if (this.errors.length === 0) await this.getProductUnitsOfMeasurement();
      if (this.errors.length === 0) await this.getMedicineUnitOfMeasurement();
      if (this.errors.length === 0) await this.getActiveIngredient();
      if (this.errors.length === 0) await this.getTypesOfMedicine();
      if (this.errors.length === 0) await this.getTypesOfRecipe();
    },

    async getConfigNfe() {
      try {
        const response = await api.get("/rest-home/settings/nfe");

        const { error, nfe_change_name_item } = response.data;

        if (!error) {
          this.nfe_change_name_item = nfe_change_name_item;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getResidents() {
      this.loading = true;
      let { status_resident } = this;
      const { error, errors, residents } = await APIGet.getResidents({
        status_resident,
      });
      this.errors = errors;
      this.raw_residents = error ? [] : residents;
      this.loading = false;
    },

    async getStockItemUnitsOfMeasurement() {
      this.loading = true;
      const { error, errors, stock_item_units_of_measurement } =
        await APIGet.getStockItemUnitsOfMeasurement();
      this.errors = errors;
      this.stock_item_units_of_measurement = error
        ? []
        : stock_item_units_of_measurement;
      this.loading = false;
    },

    handleChangeType() {
      this.getStockGroups();
    },

    async getStockGroups() {
      this.loading = true;
      let { type } = this;
      let params = { type };
      const { error, errors, stock_groups } = await APIGet.getStockGroups(
        params
      );
      this.errors = errors;
      this.stock_groups = error ? [] : stock_groups;
      this.loading = false;
    },

    async getStockGroupsAssociatedCategories() {
      this.loading = true;
      const { error, errors, associations } =
        await APIGet.getStockGroupsAssociatedCategories();
      this.errors = errors;
      this.stock_group_has_stock_item_category = error ? [] : associations;
      this.loading = false;
    },

    async getStockItemsByProviderID() {
      if (!this.financial?.providerId) return;
      this.loading = true;
      const { error, errors, stock_items } =
        await APIGet.getStockItemsByProviderID({
          provider_id: this.financial?.providerId ?? null,
        });
      this.errors = errors;
      this.stock_items_by_provider_id = error ? [] : stock_items;
      this.loading = false;
    },

    async getStockItems(search = null) {
      try {
        this.loading = true;

        let { type } = this;

        const params = {
          page: 1,
          itemsPerPage: 25,
          search,
          type,
        };

        const response = await api.get("/rest-home/stock/items", { params });

        const { error, errors, stock_items } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.stock_items = stock_items;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getCategories() {
      try {
        this.loading = true;

        const params = { active: this.active, type: "PRODUCT" };
        const response = await api.get("/rest-home/stock/items/categories", {
          params,
        });
        const { error, errors, stock_item_categories } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          for (let item of stock_item_categories) {
            item.name = `${item.name} (${item.stock_item_type_name})`;
          }

          this.stock_item_categories = stock_item_categories;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async getMedicineUnitOfMeasurement() {
      try {
        const response = await api.get("/rest-home/unit-of-measurement/all");

        const { error, errors, unit_of_measurement } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.unitOfMeasurements = unit_of_measurement;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getProductUnitsOfMeasurement() {
      try {
        this.loading = true;

        const response = await api.get("/units-of-measurement/from-products");
        const { error, errors, units_of_measurement } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.units_of_measurement = units_of_measurement;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getActiveIngredient() {
      try {
        const response = await api.get("/rest-home/active-ingredients");

        const { error, errors, active_ingredient } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.active_ingredient = active_ingredient;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getTypesOfMedicine() {
      try {
        const response = await api.get("/rest-home/type-of-medicine/all");

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typesOfMedicine = types;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getTypesOfRecipe() {
      try {
        const response = await api.get("/rest-home/type-of-recipe/all");

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typesOfRecipe = types;
        }
      } catch (error) {
        console.log(error);
      }
    },
    //#endregion

    //#region formatters
    providerText(provider) {
      let text = provider.company_name;
      if (provider.cpf_cnpj) text += ` (${provider.cpf_cnpj})`;
      return text;
    },
    //#endregion

    //#region funcional
    openImportNFe() {
      this.importInput.click();
    },

    async importNFe() {
      const files = this.importInput.files;

      this.imported_nfe = false;

      if (files.length !== 1) {
        return;
      }

      this.imported_nfe = true;
      this.verified = false;

      const file = files[0];
      const reader = new FileReader();

      reader.onload = (ev) => this.parseNFeDetails(ev.target.result);
      reader.readAsText(file);
    },

    parseNFeDetails(xmlString) {
      this.importInput.value = null;

      this.nfe = parseNFeV4(xmlString);

      // chave de acesso NF-e
      this.financial.description = this.nfe.nfeProc.NFe.infNFe._attributes.Id;

      // natureza da operação
      this.financial.note = this.nfe.nfeProc.NFe.infNFe.ide.natOp._text;

      this.parseNFeProvider();
      this.parseNFeItems().then();

      if (this.nfe.nfeProc.NFe.infNFe._attributes.Id) {
        this.nfeId = this.nfe.nfeProc.NFe.infNFe._attributes.Id;
      }
    },

    parseNFeProvider(data = null) {
      if (data) {
        this.original_providers = data.providers;
      }

      if (!this.nfe) return;

      let find = this.providers.find((provider) => {
        return (
          numbersOnly(provider.cpf_cnpj) ===
          this.nfe.nfeProc.NFe.infNFe.emit.CNPJ._text
        );
      });

      if (find) {
        this.financial.providerId = find.id;
      }

      // novo fornecedor
      if (this.financial?.providerId === null) {
        this.new_provider.company_name =
          this.nfe.nfeProc.NFe.infNFe.emit.xNome._text;
        this.new_provider.cpf_cnpj =
          this.nfe.nfeProc.NFe.infNFe.emit.CNPJ._text;
      } else {
        this.new_provider.company_name = "";
        this.new_provider.cpf_cnpj = "";
      }
    },

    async parseNFeItems() {
      let { nfe, stock_items_by_provider_id } = this;

      if (!nfe) return;

      await this.getStockItemsByProviderID();

      this.purchase_items = [];
      for (const det of nfe.nfeProc.NFe.infNFe.det) {
        const stock_item = stock_items_by_provider_id.find(
          (stock_item) => stock_item.code === det.prod.cProd._text
        );

        let amount = det.prod.qTrib._text ? Number(det.prod.qTrib._text) : 1;

        let qCom = det.prod.qCom._text;
        let vUnCom = det.prod.vUnCom._text;

        let quantity_value = parseFloat(qCom).toFixed(2);
        let unitary_value = parseFloat(vUnCom).toFixed(2);

        let value_total = parseFloat(qCom) * parseFloat(vUnCom);

        value_total = value_total.toFixed(2);
        value_total = formatValueOnKeyUp(String(value_total));

        this.purchase_items.push({
          stock_item_id: stock_item?.id ?? null,
          amount,
          // amount: this.convertNFeUnitOfMeasurement(
          //   stock_item?.size ?? 1,
          //   det.prod.qCom._text,
          //   det.prod.uCom._text
          // ),
          lot: "",
          description: "",
          due_date: "",
          stock_group_id: null,
          value: formatValueOnKeyUp(String(det.prod.vProd._text)),
          value_total,
          unitary_value,
          quantity_value,

          stock_item_locked: Boolean(stock_item),
          status: this.purchase_item_status[stock_item ? "WARNING" : "ERROR"],

          imported_nfe: true,
          nfe_name: det.prod.xProd._text,
          nfe_code: det.prod.cProd._text,
          nfe_amount: `${localeFormat(det.prod.qCom._text)} ${
            det.prod.uCom._text
          }`,
        });
      }

      // totais
      this.purchase_shipping_total.value =
        this.nfe.nfeProc.NFe.infNFe.total.ICMSTot.vFrete._text;
      this.purchase_items_total.value =
        this.nfe.nfeProc.NFe.infNFe.total.ICMSTot.vProd._text;
      this.purchase_discount_total.value =
        this.nfe.nfeProc.NFe.infNFe.total.ICMSTot.vDesc._text;
      this.purchase_total.value =
        this.nfe.nfeProc.NFe.infNFe.total.ICMSTot.vNF._text;

      const cobr = this.nfe.nfeProc.NFe.infNFe.cobr;

      // valor do lançamento
      if (cobr) {
        // duplicatas declaradas na nota fiscal

        if (Array.isArray(cobr.dup)) {
          // mais de uma duplicata

          this.financial.launchings = cobr.dup.map((dup) => ({
            launchIndex: dup.nDup._text,
            dueDate: dup.dVenc._text,
            value: dup.vDup._text,
          }));

          const launch = this.financial.launchings.shift();
          this.financial.dueDatePaymentDate = launch.dueDate;
          this.financial.launchValue = launch.value;
        } else {
          // apenas uma duplicata

          this.financial.launchings = [];
          this.financial.dueDatePaymentDate = cobr.dup.dVenc._text;
          this.financial.launchValue = cobr.dup.vDup._text;
        }
      } else {
        // duplicatas não informadas, usamos o valor total da nota como valor do débito

        this.financial.launchings = [];
        this.financial.launchValue =
          this.nfe.nfeProc.NFe.infNFe.total.ICMSTot.vNF._text;
      }

      await this.handleStockOwnerGroupId();
    },

    async refreshNFeItems() {
      if (!this.nfe) return;

      await this.getStockItemsByProviderID();

      for (const purchase_item of this.purchase_items) {
        const stock_item = this.stock_items_by_provider_id.find(
          (stock_item) => stock_item.code === purchase_item.nfe_code
        );

        purchase_item.stock_item_id = stock_item?.id ?? null;
        purchase_item.stock_item_locked = Boolean(stock_item);
      }
    },

    /**
     * @param {number} stock_item_size
     * @param {number} nfe_amount quantidade
     * @param {string} nfe_commercial_unit unidade de medida
     * @returns {number}
     */
    convertNFeUnitOfMeasurement(
      stock_item_size,
      nfe_amount,
      nfe_commercial_unit
    ) {
      nfe_amount = Number(nfe_amount);

      const rule = new RegExp(/^([A-Za-z]+)(\d*)$/);
      if (!nfe_commercial_unit.match(rule)) return null;

      // const type = nfe_commercial_unit.replace(rule, "$1");
      const multiple = Number(nfe_commercial_unit.replace(rule, "$2")) || 1;

      return stock_item_size * multiple * nfe_amount;
    },

    async execute() {
      try {
        this.loading = true;

        let {
          nfeId,
          financial,
          stock_owner_id,
          purchase_total,
          purchase_items,
        } = this;

        const data = {
          nfeId,
          ...financial,
          stock_owner_id,
          totalValue: purchase_total.value,
          items: purchase_items.map((item) => ({
            stock_item_id: item.stock_item_id,
            size: item.size,
            amount: item.amount,
            quantity: item.quantity,
            lot: item.lot,
            description: item.description,
            due_date: item.due_date,
            stock_group_id: item.stock_group_id,
            value: item.value,
            stock_item_type: item.stock_item_type,
            name: item.name,
            medicine_id: item.medicine_id,
            product_id: item.product_id,
            imported_nfe: item.imported_nfe ?? false,
            imported_nfe_type: item.imported_nfe_type ?? null,
            nfe_amount: item.nfe_amount ?? null,
            nfe_code: item.nfe_code ?? null,
            nfe_name: item.nfe_name ?? null,
          })),
        };
        const response = await api.post("/rest-home/stock/purchase", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.purchase_items = [];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async evOnPurchaseItemCreated(data) {
      this.purchase_items.push({
        ...data,
        status: this.purchase_item_status.VERIFIED,
      });
      this.purchase_items_total.value = this.computed_purchase_items_total;
      this.updateFinancialLaunchValue();
    },

    async evOnPurchaseItemUpdated(data) {
      const { index } = data;
      delete data.index;

      const purchase_item = {
        ...this.purchase_items[index],
        ...data,
        status: this.purchase_item_status.VERIFIED,
      };

      this.purchase_items.splice(index, 1, purchase_item);

      this.purchase_items_total.value = this.computed_purchase_items_total;
      this.updateFinancialLaunchValue();

      await this.refreshNFeItems();
    },

    async handleValueStockItemPriceList(data) {
      let { index } = data;

      delete data.index;

      let purchase_item = {
        ...this.purchase_items[index],
        ...data,
      };

      this.purchase_items.splice(index, 1, purchase_item);

      this.purchase_items_total.value = this.computed_purchase_items_total;
      this.updateFinancialLaunchValue();

      await this.refreshNFeItems();

      this.$bvModal.hide("stock_item_price_list");
    },

    removePurchaseItem(item) {
      const index = this.purchase_items.findIndex(
        (purchase_item) => purchase_item === item
      );
      this.purchase_items.splice(index, 1);
      this.purchase_items_total.value = this.computed_purchase_items_total;
      this.updateFinancialLaunchValue();
    },

    openNewItem(modal_id) {
      this.new_item_name = this.purchase_item.nfe_name;
      this.$bvModal.show(modal_id);
    },

    updateFinancialLaunchValue() {
      let {
        purchase_shipping_total,
        purchase_items_total,
        purchase_discount_total,
      } = this;

      let shipping = purchase_shipping_total.value; // TRANSPORTE/FRETE
      let items_total = purchase_items_total.value; // TOTAL PRODUTOS
      let discount = purchase_discount_total.value; // DESCONTOS

      let launchValue = parseFloat(items_total);

      if (shipping && parseFloat(shipping) > 0) {
        launchValue = parseFloat(launchValue) + parseFloat(shipping);
      }

      if (discount && parseFloat(discount) > 0) {
        launchValue = parseFloat(launchValue) - parseFloat(discount);
      }

      this.financial.launchValue = launchValue.toFixed(2);
    },
    //#endregion
  },
};
</script>

<style>
.warning-alert {
  background-color: #fff3cd !important;
  text-transform: uppercase;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 10px;
  color: #997404;
  font-size: 13px;
  font-weight: 500;
}
</style>